import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/home/travis/build/gramps-graphql/gramps/docs/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const AnchorLinks = makeShortcode("AnchorLinks");
const AnchorLink = makeShortcode("AnchorLink");
const Row = makeShortcode("Row");
const Column = makeShortcode("Column");
const ImageCard = makeShortcode("ImageCard");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`At this point, we have our `}<a parentName="p" {...{
        "href": "/data-souce-tutorial/connector"
      }}>{`connector`}</a>{`, `}<a parentName="p" {...{
        "href": "/data-souce-tutorial/model"
      }}>{`model`}</a>{`, `}<a parentName="p" {...{
        "href": "/data-souce-tutorial/schema"
      }}>{`schema`}</a>{`, and `}<a parentName="p" {...{
        "href": "/data-souce-tutorial/resolvers"
      }}>{`resolvers`}</a>{` built and ready to go. All that’s left to do is fire up our data source in mock and live mode to make sure it’s working.`}</p>
    <h2 {...{
      "id": "table-of-contents"
    }}>{`Table of Contents`}</h2>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/data-source-tutorial/setup"
        }}>{`Initial Data Source Setup`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/data-source-tutorial/connector"
        }}>{`Create a Connector`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/data-source-tutorial/model"
        }}>{`Create a Model`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/data-source-tutorial/schema"
        }}>{`Write a GraphQL Schema`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/data-source-tutorial/resolvers"
        }}>{`Write Resolvers`}</a></li>
      <li parentName="ul"><strong parentName="li">{`> `}<a parentName="strong" {...{
            "href": "/data-source-tutorial/dev"
          }}>{`Use Development Modes`}</a></strong></li>
    </ul>
    <h2 {...{
      "id": "in-this-section"
    }}>{`In This Section`}</h2>
    <AnchorLinks mdxType="AnchorLinks">
  <AnchorLink mdxType="AnchorLink">Run the Data Source in Mock Data Mode</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Run the Data Source in Live Data Mode</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Further Reading</AnchorLink>
    </AnchorLinks>
    <h2 {...{
      "id": "run-the-data-source-in-mock-data-mode"
    }}>{`Run the Data Source in Mock Data Mode`}</h2>
    <p>{`To test the data source with mock data, open your terminal and run the following command:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`yarn mock-data
`}</code></pre>
    <p>{`Then open `}<inlineCode parentName="p">{`http://localhost:8080/graphiql`}</inlineCode>{` in your browser and run a test query. You’ll see the GraphiQL user interface, and you can make a test query like this:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-graphql"
      }}>{`query searchMoviesByTitle($options: IMDB_MovieSearchInput) {
  searchMoviesByTitle(options: $options) {
    imdb_id
    title
    genre
    year
  }
}
`}</code></pre>
    <p>{`The result will be mock data that looks something like this:`}</p>
    <Row className="image-card-group" mdxType="Row">
      <Column colMd={12} noGutterSm mdxType="Column">
  <ImageCard aspectRatio="16:9" mdxType="ImageCard">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "50.356506238859176%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAAAsSAAALEgHS3X78AAABpElEQVQoz4VSia7bIBD0///ia5qXOja2iQGDuXxkOtCkh1S1K41AsMzOztKI2xdc7jdcrzfMjxlaGwgh0H5r0d073F+o+/YHuq6H6AUul6+4fd4wcH+9dvj4uKC53wUvB0xSYpomyElCPRSMsSRfYFhAK/Na9U8sZsE4TFCKOcuKaXZYV49GPR6YugGy42UvIUeSzgOcmeCdQliX+lg/SGJXLHzkQoDj6kPkmcM8a5KtOM8TTU4J7aBZxWNLG3LKSFvAsWc8nwdxIsUEKQ2uo2YHBnY0iCEhMd9aSzjmPSua4AMCL/4VOW9wPqJtJfxsCQev10palEZvsG8RT+Y2RVGJd4W/IeeMxa301CHYgJhLFzvytmFUDv0gkLyqPM2xH/hflKLGeXwOCk4ucL1GcAGJyiWLGCWqNZXQsf+FEy1rpFcVNPt3VFtihvwYsJKgEJW8N+GiBc4jV9LGew9jWZHrkfeK8zjrxN5IVGjplTH07aUs8ixyoKPil5EC0fY4jg1NUZA5lD2RLGQckQN6/tlyYM5KlcW3X2T5pZBT1iTjzyjxHZLUAotXdjoEAAAAAElFTkSuQmCC')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "A GrAMPS data source running in mock data mode",
              "title": "A GrAMPS data source running in mock data mode",
              "src": "/static/7c6073cc1823b0205381a8a8a260eb45/fb070/data-source-mock-data.png",
              "srcSet": ["/static/7c6073cc1823b0205381a8a8a260eb45/d6747/data-source-mock-data.png 288w", "/static/7c6073cc1823b0205381a8a8a260eb45/09548/data-source-mock-data.png 576w", "/static/7c6073cc1823b0205381a8a8a260eb45/fb070/data-source-mock-data.png 1152w", "/static/7c6073cc1823b0205381a8a8a260eb45/fb104/data-source-mock-data.png 1728w", "/static/7c6073cc1823b0205381a8a8a260eb45/298aa/data-source-mock-data.png 2244w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "loading": "lazy"
            }}></img>{`
    `}</span>
  </ImageCard>
      </Column>
    </Row>
    <h2 {...{
      "id": "run-the-data-source-in-live-data-mode"
    }}>{`Run the Data Source in Live Data Mode`}</h2>
    <p>{`To use live data, stop the server (`}<inlineCode parentName="p">{`control`}</inlineCode>{` + `}<inlineCode parentName="p">{`C`}</inlineCode>{`), then run this command:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`yarn live-data
`}</code></pre>
    <p>{`Then go back to `}<inlineCode parentName="p">{`http://localhost:8080/graphiql`}</inlineCode>{` and run the same command we used with the mock data:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-graphql"
      }}>{`query searchMoviesByTitle($options: IMDB_MovieSearchInput) {
  searchMoviesByTitle(options: $options) {
    imdb_id
    title
    genre
    year
  }
}
`}</code></pre>
    <p>{`This time you’ll get back a response with live data!`}</p>
    <blockquote>
      <p parentName="blockquote"><strong parentName="p">{`NOTE:`}</strong>{` Unfortunately, it turns out the IMDB API is pretty unreliable and
frequently goes down. It’s
`}<a parentName="p" {...{
          "href": "https://github.com/gramps-graphql/gramps-express/issues/31"
        }}>{`on our todo list`}</a>{`
to update this tutorial with a more reliable data source. (Want to contribute?
We’d love to have you participate —
`}<a parentName="p" {...{
          "href": "https://github.com/gramps-graphql/gramps-express/issues/31"
        }}>{`get involved`}</a>{`!)`}</p>
    </blockquote>
    <h2 {...{
      "id": "further-reading"
    }}>{`Further Reading`}</h2>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/gramps-graphql/data-source-imdbapi"
        }}>{`Review the full source code of the GrAMPS data source for the IMBDAPI`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      